const axios = require('axios')
// const qs = require('qs')
const Header = require('./auth')
const {
    PHOTO_FIND_URL,
    PHOTO_ADD_URL,
    PHOTO_DEL_URL
} = require('./url')

/* 获取商品图片 */
function getProductImgList (productId) {
    Header.axiosStop()
    return new Promise((resolve, reject) => {
    axios.get(`${PHOTO_FIND_URL}/${productId}`)
        .then(res => {
        // console.log(res)
        resolve(res)
        })
        .catch(err => {
        reject(err)
        })
    })
}

/* 新增商品图片 */
function addProductImg (sendData) {
  Header.axiosStop()
  return new Promise((resolve, reject) => {
    axios.post(`${PHOTO_ADD_URL}/${sendData.productId}`,
      {
        productImg: sendData.productImg // 商品图片
      }
    )
      .then(res => {
        // console.log(res)
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/* 通过商品ID删除商品图片 */
function deleteProductImgId (id) {
  return new Promise((resolve, reject) => {
    axios.delete(`${PHOTO_DEL_URL}/${id}`)
      .then(res => {
        // console.log(res)
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
module.exports = {
    getProductImgList,
    addProductImg,
    deleteProductImgId
}
